module.exports = __webpack_public_path__ + "img/xiaomeng.aa499b13.png";